import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";



// GET DETALLES DE UNA REQUISA 
export const getDetalleRequisa = async (PurchaseRequest) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/getDetalleRequisa`, 'POST', { PurchaseRequest })
    return result;
}

// GET DETALLES DE UNA REQUISA 
export const DetallesRequisa = async () => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/DetallesRequisa`, 'GET')
    return result;
}


// GET DETALLES DE REQUISA FILTRADORS POR FECHA
export const getRequisasDetalle = async (data) => {
    return await PrivateInterceptor('Compras/RequisasCompras/listadoRequisasPorFecha', 'POST', data);
  }

  // ASIGNAR A UN AGENTE DE COMPRAS
export const assignAgent = async (body) => {
    const respuesta = await PrivateInterceptor('Compras/RequisasCompras/ChangeAgent', 'PUT', body);
    return respuesta;
}

// GET DETALLES DE UNA REQUISA 
export const getDetalleRequisaID = async (IdPurchaseRequest) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/getDetalleRequisaId`, 'POST', { IdPurchaseRequest })
    return result;
}

// GET DETALLES DE UNA REQUISA 
export const getEncabezadoRequisaID = async (IdPurchaseRequest) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/getEncabezadoRequisaId`, 'POST', { IdPurchaseRequest })
    return result;
}

// GET DETALLES DE UNA REQUISA POR ASIGNACION
export const getDetallePorAsignacion = async (IdOrdenDeTrabajoEnc) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/getRequisaPorAsignacion`, 'POST', { IdOrdenDeTrabajoEnc })
    return result;
}
